import { configureStore } from "@reduxjs/toolkit";
import SidebarSlice from "./slice/SidebarSlice";

const store = configureStore({
    reducer:{
    SidebarSlice : SidebarSlice
    }   
})
export default store